import React from 'react';
import { Link } from 'react-router-dom';
import TestimonialCard from '../components/TestimonialCard';


const Home = () => {
  const stats = [
    { number: '10,000+', label: 'Students Trained' },
    { number: '92%', label: 'Cohort Completion Rate' },
    { number: '10+', label: 'Industry Mentors' },
    { number: '3', label: 'Specialized Programs' }
  ];

  const courses = [
    {
      id: 'equity-research',
      title: 'Equity Research & Financial Modeling',
      duration: '5 weeks',
      price: '₹1,999',
      description: 'Master equity research through hands-on financial modeling with industry experts',
      features: ['Revenue Modeling', 'Build Schedules', '3-Statement Linked Model', 'DCF & Relative Valuation']
    },
    {
      id: 'fixed-income',
      title: 'Fixed Income & Credit Analysis',
      duration: '5 weeks', 
      price: '₹2,999',
      description: 'Deep-dive into bond valuation and credit risk assessment',
      features: ['Bond valuation models', 'Portfolio Sensitivity', 'Credit risk metrics', 'Altman Z-Score']
    },
    {
      id: 'quantitative-finance',
      title: 'Quantitative Finance',
      duration: '5 weeks',
      price: '₹2,999', 
      description: 'Learn Python for portfolio optimization and risk management',
      features: ['Python programming', 'Portfolio optimization', 'Monte Carlo simulation', 'VaR implementation']
    }
  ];

  const testimonials = [
  {
    name: 'Deependra Patidar',
    role: 'MBA, IIM Nagpur',
    quote: 'When I joined IIM Nagpur, I was sure to take a marketing role as I had work ex of 2 years in marketing, and finance was just a boring subject for me. I struggled to choose between finance and marketing as everyone suggested I should go for finance due to my maths background, and then this live project by Aniket came into the picture, and I registered for it. The way of his teaching was fabulous, and I realised that finance can be this interesting. I have done valuation for many companies after that, and every time I do, I learn something new. It was a great experience learning with you, and I am eagerly waiting for the latest projects you may float. ',
    image: '/deep.jpg',
    linkedin: 'https://www.linkedin.com/in/deependra-patidar'
  },
  {
    name: 'Pranav Girgaonkar',
    role: 'MBA Finance, SIBM Nagpur',
    quote: 'I am a engineer turned MBA Finance major, thought valuation and equity research was a tough thing to understand and that too in a short time frame, but Aniket Sir made it easy, I was able to grasp most of the concepts with not much difficulty. Whenever I had any doubt during my personal alloted exercise, he was always there to help and the best part was there werent any time constraints to contact him, his accessibility and his patience to explain even the most trivial things at times made the exercise comprehensible. ',
    image: '/pranav.jpg',
    linkedin: 'https://www.linkedin.com/in/pranav-girgaonkar'
  },
  {
    name: 'Rakshit Chavakula',
    role: 'MBA, IIM Lucknow',
    quote: 'I had the privilege of working on a Live project with Intlrr/Alvron Partners, and I owe a huge thanks to  Aniket  for his exceptional mentoring throughout. His guidance in mastering finance domain intricacies, from constructing financial models to evaluating market prices, was invaluable. With his support, I gained a comprehensive understanding of the industry and honed practical financial skills. Excited to leverage these learnings for future growth.',
    image: '/rakshit.jpg',
    linkedin: 'https://www.linkedin.com/in/rakshit-chavakula-1877b99a'
  }
];


  return (
    <div className="home" data-testid="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content animate-fade-in-up">
            <h1 className="heading-primary mb-lg">
              Master Finance with
              <span style={{ color: 'var(--secondary)' }}> Industry Experts</span>
            </h1>
            <p className="text-large mb-xl" style={{ color: 'var(--text-secondary)', maxWidth: '600px' }}>
              Join cohort-based learning programs designed to accelerate your career in finance. 
              Get hands-on experience, industry mentorship, and placement support.
            </p>
            <div className="flex gap-md">
              <Link to="/programs" className="btn btn-primary btn-large" data-testid="explore-programs-btn">
                Explore Programs
              </Link>
              <Link to="/contact" className="btn btn-outline btn-large" data-testid="book-call-btn">
                Book a Call
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section-sm" style={{ background: 'var(--surface)' }}>
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item animate-fade-in" data-testid={`stat-${index}`}>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-2xl">
            <h2 className="heading-secondary mb-md">Our Programs</h2>
            <p className="text-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
              Comprehensive cohort-based programs designed to give you real-world finance experience
            </p>
          </div>
          
          <div className="grid grid-3 gap-lg">
            {courses.map((course, index) => (
              <div key={course.id} className="card course-card" data-testid={`course-card-${course.id}`}>
                <div className="course-price">{course.price}</div>
                <h3 className="heading-tertiary mb-sm">{course.title}</h3>
                <p className="text-sm mb-md" style={{ color: 'var(--text-secondary)' }}>
                  Duration: {course.duration}
                </p>
                <p className="text-base mb-md">{course.description}</p>
                
                <ul className="course-features">
                  {course.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
                
                <Link 
                  to={`/programs/${course.id}`} 
                  className="btn btn-secondary" 
                  style={{ width: '100%', marginTop: 'auto' }}
                  data-testid={`learn-more-${course.id}`}
                >
                  Learn More
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section" style={{ background: 'var(--surface)' }}>
        <div className="container">
          <div className="grid grid-2 gap-xl items-center">
            <div>
              <h2 className="heading-secondary mb-lg">Why Choose Intlrr?</h2>
              <div className="grid gap-md">
                <div className="flex gap-md">
                  <div className="flex-shrink-0">
                    <div style={{ width: '48px', height: '48px', background: 'var(--secondary)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ color: 'white', fontSize: '24px' }}>🎯</span>
                    </div>
                  </div>
                  <div>
                    <h3 className="heading-tertiary mb-xs" style={{ fontSize: '1.25rem' }}>Industry-Ready Skills</h3>
                    <p style={{ color: 'var(--text-secondary)' }}>Learn practical skills that employers actually need, taught by industry professionals.</p>
                  </div>
                </div>
                
                <div className="flex gap-md">
                  <div className="flex-shrink-0">
                    <div style={{ width: '48px', height: '48px', background: 'var(--accent)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ color: 'white', fontSize: '24px' }}>👥</span>
                    </div>
                  </div>
                  <div>
                    <h3 className="heading-tertiary mb-xs" style={{ fontSize: '1.25rem' }}>Expert Mentorship</h3>
                    <p style={{ color: 'var(--text-secondary)' }}>Get guidance from finance professionals currently working in top firms.</p>
                  </div>
                </div>
                
                <div className="flex gap-md">
                  <div className="flex-shrink-0">
                    <div style={{ width: '48px', height: '48px', background: 'var(--primary)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ color: 'white', fontSize: '24px' }}>🚀</span>
                    </div>
                  </div>
                  <div>
                    <h3 className="heading-tertiary mb-xs" style={{ fontSize: '1.25rem' }}>Placement Support</h3>
                    <p style={{ color: 'var(--text-secondary)' }}>Comprehensive career support including resume building and interview preparation.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="https://images.unsplash.com/photo-1526628953301-3e589a6a8b74" 
                alt="Financial Analysis" 
                style={{ width: '100%', borderRadius: '1.5rem', boxShadow: 'var(--shadow-xl)' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-2xl">
            <h2 className="heading-secondary mb-md">Success Stories</h2>
            <p className="text-large" style={{ color: 'var(--text-secondary)' }}>
              Hear from our alumni who have successfully launched their finance careers
            </p>
          </div>
          
          <div className="grid grid-3 gap-lg">
            {testimonials.map((testimonial, index) => (
  <TestimonialCard
    key={index}
    quote={testimonial.quote}
    name={testimonial.name}
    role={testimonial.role}
    linkedin={testimonial.linkedin}
    image={testimonial.image}
  />
))}

          </div>

          {/* ADDED: View all testimonials button */}
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/testimonials" className="btn btn-secondary btn-large">
              View all testimonials 
            </Link>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="section" style={{ background: 'var(--primary)', color: 'white' }}>
        <div className="container text-center">
          <h2 className="heading-secondary mb-md" style={{ color: 'white' }}>
            Ready to Launch Your Finance Career?
          </h2>
          <p className="text-large mb-xl" style={{ color: 'rgba(255, 255, 255, 0.9)', maxWidth: '600px', margin: '0 auto 2rem' }}>
            Join hundreds of students who have successfully transitioned into finance roles with our expert guidance.
          </p>
          <div className="flex gap-md justify-center">
            <Link to="/programs" className="btn btn-secondary btn-large" data-testid="start-learning-btn">
              Start Learning Today
            </Link>
            <Link to="/contact" className="btn btn-outline btn-large" style={{ color: 'white', borderColor: 'white' }} data-testid="schedule-call-btn">
              Schedule a Call
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
